import React, {useState, useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toTime, toTimeType, timeConverter, isObjectEmpty, uploadCSV, replaceAll, timeConverterSM, toArray} from '../../../../Utils';
import Spinner from '../../../common/generic/Spinner';

const ContainerComp = ({pageState, reportState, csvData, setcsvData}) =>{
    const {database, deleteThis, request, fetchModules, modulesData, modulesReady } = pageState;
    const [processedMarks, setProcessedMarks] = useState({});
    const [markRecords, setMarkRecords] = useState({});
    const {selectedStudents, selectedProgram} = reportState;
    const [totals, setTotals] = useState({});

    /*
    CSV NOTES
    =========
    There is a big problem when trying to upload more then 1 csv file.  The below system will reset all the data in 
    this component and start it over when when the user clicks save.
    
    Steps
    1) User clicks save in either ProgramReportTableComp or AcitivityReportComp
        1b) openCSVPage() will populate csvData using setcsvData({processStage:'newRequest'});
    2) ViewReportsPage checks to see if the marks have changed (* seems to be called way to many times...)
        2b) setReportType(csvData.reportType);
            setSelectedProgram({...csvData.selectedProgram});
            setSelectedStudents([...csvData.selectedStudents]); 
    3) Start the report
        3a) CSV Step 1: checks if a new request for csv and starts to clear the data
        3b) CSV Step 2: clears the data 
        3c) CSV Step 3: keep checking to see when the data has been cleared
        3d) CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
        3e) (The normal Startup starts at CSV Step 1) 
    */

    // CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
    // The normal Startup starts at CSV Step 1 
    const tryLoadingCSVStage2 = () => {
        if(!csvData) return;
        if(csvData.processStage === 'clearingData'){
            if(!database['getMadMinuteMarks'] && isObjectEmpty(markRecords) && isObjectEmpty(processedMarks)){
                setcsvData({...csvData, processStage:'clearedData'});
            }
        }
    };
    // CSV Step 3: keep checking to see when the data has been cleared
    useEffect(() =>{tryLoadingCSVStage2();},[database['getMadMinuteMarks']]);
    useEffect(() =>{tryLoadingCSVStage2();},[markRecords]);
    useEffect(() =>{tryLoadingCSVStage2();},[processedMarks]);

    // CSV Step 2: clears the data
    useEffect(() => {
        if(!csvData) return;

        if(csvData.processStage === 'clearingData'){
            deleteThis('getMadMinuteMarks');
            setMarkRecords({});
            setProcessedMarks({});
        }
    },[csvData]);

    // CSV Step 1: checks if a new request for csv and starts to clear the data 
    // Normal Startup Step 1:
    useEffect(() => {
        if(csvData){
            if(csvData.processStage==='newRequest'){
                // csvData.setloadingCSV({...csvData.loadingCSV, MMStatus:true});
                setcsvData({...csvData, processStage:'clearingData'});
                return;
            }

            if(csvData.processStage==='clearingData') return;
        }

        if(!isObjectEmpty(markRecords)) return; // already loading

        if(!database['getMadMinuteMarks']){
            let studentQueries = selectedStudents.map(studentRec=>{
                let getMarksQuery={
                    params: studentRec.id,
                    func:'getMadMinuteMarks'            
                };
                return getMarksQuery;
            });

            if(studentQueries.length > 0){
                let counter = 1;
                studentQueries = studentQueries.map((query,i)=>{
                    let prevQuery = (i!=0) ? studentQueries[i-1] : 'undefinded';
                    if(prevQuery !== 'undefinded'){
                        counter++;
                        query.nextRequest = prevQuery;
                    }
                    return query;
                });
                let loadChainedMarks = studentQueries[studentQueries.length-1];
                loadChainedMarks.numQueries = counter;
                setMarkRecords({info:{numStudents:counter,numLoaded:counter}});

                // pass the link list of saved changes into the database
                request(loadChainedMarks); 
            }
            else
                console.log('Nothing to load?');
        }
    });

    // convert database['getMadMinuteMarks'] into setMarkRecords
    // UDATES - when database['getMadMinuteMarks'] changes
    useEffect(() => {
        if(csvData && csvData.processStage !== 'clearedData') return; // don't setup markRecords for csv files without being ready 
        if(isObjectEmpty(markRecords)) return;
        (!pageState.isFetchingModules && !modulesReady) && fetchModules(selectedProgram.id.toLowerCase());
        if(!database['getMadMinuteMarks']) return;
        
        let marks = {};
        let key = 'unavailable';
        let counter = {...markRecords.info};

        if(database['getMadMinuteMarks'].isLoaded) counter.numLoaded--;
        
        marks = {
            isloaded: database['getMadMinuteMarks'].isLoaded,
            data: database['getMadMinuteMarks'].data
        }; 

        if((marks.data) && !isObjectEmpty(marks.data)){
            key = Object.keys(marks.data)[0].split('+')[0];
        }

        setMarkRecords({...markRecords, info:{...counter}, [key]:marks});

    }, [database['getMadMinuteMarks']]); 

    const tryLoadingNow = () => {
        if(isObjectEmpty(markRecords)) return;
        if(!isObjectEmpty(processedMarks)) return;
        if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return;

        let reportData = JSON.parse(localStorage.getItem('reportData'));
        let masterLevel = parseInt(reportData.masterLevel)/100;

        //console.log('markRecords',markRecords);
        let studentMarks = selectedStudents.reduce((acc,studentRec)=>{
            let studentID = studentRec.id;
            let studentMarkRecords = markRecords[studentID];
            if(!studentMarkRecords) return acc; // still loading marks

            let mergedMarks = toArray(studentMarkRecords.data).reduce((markAcc, markRecord)=>{

                const addMark = (fact, factName) =>{
                    //console.log('markRecord[`${fact}QuestionsRight`]',markRecord,`markRecord[${fact}Drills]`);
                    if(!markAcc[fact]){
                        if(markRecord[`${fact}Drills`]){
                            markAcc[fact] = {};
                            markAcc[fact].Correct = parseInt(markRecord[`${fact}QuestionsRight`]);
                            markAcc[fact].Drills = parseInt(markRecord[`${fact}Drills`]);
                            markAcc[fact].Mastered = parseInt(markRecord[`${fact}Mastered`]);
                            markAcc[fact].Questions = parseInt(markRecord[`${fact}QuestionsAttempted`]);

                            if(markAcc.CurrentFact && markAcc.CurrentFact.fact && markAcc.CurrentFact.dayDate < markRecord.DayDate)
                                markAcc.CurrentFact = {fact:fact, dayDate:markRecord.DayDate};                                
                            if(!markAcc.CurrentFact || !markAcc.CurrentFact.fact)
                                markAcc.CurrentFact = {fact:fact, dayDate:markRecord.DayDate};                            
                        }
                    }
                    else{
                        if(markRecord[`${fact}Drills`]){
                            markAcc[fact].Correct = parseInt(markAcc[fact].Correct) + parseInt(markRecord[`${fact}QuestionsRight`]);
                            markAcc[fact].Drills = parseInt(markAcc[fact].Drills) + parseInt(markRecord[`${fact}Drills`]);
                            markAcc[fact].Mastered = parseInt(markAcc[fact].Mastered) + parseInt(markRecord[`${fact}Mastered`]);
                            markAcc[fact].Questions = parseInt(markAcc[fact].Questions) + parseInt(markRecord[`${fact}QuestionsAttempted`]);
                            // not required
                            // if(markAcc.CurrentFact.fact && markAcc.CurrentFact.dayDate < markRecord.DayDate)
                            //     markAcc.CurrentFact = {fact:fact, dayDate:markRecord.DayDate};                                
                            // if(!markAcc.CurrentFact.fact)
                            //     markAcc.CurrentFact = {fact:fact, dayDate:markRecord.DayDate};                               
                        }
                    }
                };

                addMark('ADD', 'Add');
                addMark('SUB', 'Sub');
                addMark('MULT','Mult');
                addMark('DIV', 'Div');

                /*
                if(!markAcc[markRecord.Fact]){
                    markAcc[markRecord.Fact] = {...markRecord};
                }
                else{
                    markAcc[markRecord.Fact].Correct = parseInt(markAcc[markRecord.Fact].Correct) + parseInt(markRecord.Correct);
                    markAcc[markRecord.Fact].Drills = parseInt(markAcc[markRecord.Fact].Drills) + parseInt(markRecord.Drills);
                    markAcc[markRecord.Fact].Mastered = parseInt(markAcc[markRecord.Fact].Mastered) + parseInt(markRecord.Mastered);
                    markAcc[markRecord.Fact].Questions = parseInt(markAcc[markRecord.Fact].Questions) + parseInt(markRecord.Questions);
                }
                */
                return markAcc;
            },{});
            mergedMarks.Name = studentRec.name;
            // console.log('mergedMarks',mergedMarks);
            acc[`${studentRec.id}+${studentRec.name}`] = mergedMarks;
            return acc;
        },{});
        //console.log('studentMarks',studentMarks);
        setProcessedMarks(studentMarks);

        let studentTotals = {AddMastered:0, SubMastered:0, MultMastered:0, DivMastered:0, Drills:0};
        Object.keys(studentMarks).map((key) => {
            let markRec = studentMarks[key];
            studentTotals.AddMastered += markRec.ADD ? parseInt(markRec.ADD.Mastered) : 0;
            studentTotals.SubMastered += markRec.SUB ? parseInt(markRec.SUB.Mastered) : 0;
            studentTotals.MultMastered += markRec.MULT ? parseInt(markRec.MULT.Mastered) : 0;
            studentTotals.DivMastered += markRec.DIV ? parseInt(markRec.DIV.Mastered) : 0;
        });        
        setTotals(studentTotals);        

        if(csvData){
            let newLine = '%0A';
            let csvString = '';
            csvString +=`"Student without marks will not appear in this report"${newLine}`;

            let tableHeaderStr1 = ',,Cumulative Mastered Facts'+newLine;
            let tableHeaderStr2 = '"Student","Current Operation","+","-","*","/"'+newLine;
            let headerStr = `${newLine}"${selectedProgram.name}"${newLine}"Cumulative Report"${newLine}`;
            csvString += headerStr + tableHeaderStr1 + tableHeaderStr2;

            Object.keys(studentMarks).forEach((key) => { 
                let tableData  = studentMarks[key];
                let student = key.split('+')[1];                

                let { Mastered: AddMastered } = tableData.ADD || 0;
                let { Mastered: SubMastered } = tableData.SUB || 0;
                let { Mastered: MultMastered } = tableData.MULT || 0;
                let { Mastered: DivMastered } = tableData.DIV || 0;

                let recordStr = `"${student}","${tableData.CurrentFact.fact}","${AddMastered || 0}","${SubMastered || 0}","${MultMastered || 0}","${DivMastered || 0}"${newLine}`;
                csvString += recordStr;
            });

            let recordStr = `"Totals","","${studentTotals.AddMastered || 0}","${studentTotals.SubMastered || 0}","${studentTotals.MultMastered || 0}","${studentTotals.DivMastered || 0}"${newLine}`;
            csvString += recordStr;
                       
            let name = '';
            if(Object.keys(studentMarks).length===0){
                window.alert('There are no marks for the student(s) selected');
                csvData.setloadingCSV({...csvData.loadingCSV, MMStatus:false});
                return;
            }

            if(Object.keys(studentMarks).length===1)
                name = Object.keys(studentMarks)[0].split('+')[1]+'_';

            let today = new Date();
            today = timeConverterSM(today.getTime());

            uploadCSV(name+'CumulativeReport_'+selectedProgram.name+'_'+today,csvString);
            csvData.setloadingCSV({...csvData.loadingCSV, MMStatus:false});
        }
    }; 
    // useEffect(() =>{tryLoadingNow();},[modulesData]);
    useEffect(() =>{tryLoadingNow();},[markRecords]);

    if(csvData) return <></>;
    if(isObjectEmpty(markRecords)) return <> <Spinner/> <center>Loading... ({database['queryCount']}) </center> </>;
    if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return <> <Spinner/> <center>Loading... ({database['queryCount']}) </center> </>;

    const headerComp = <center>
    <h4><Row>
        <Col xs='4'></Col>
        <Col xs='4'>{selectedProgram.name} </Col>
        <Col xs='4'>Cumulative</Col>
    </Row></h4>
    </center>;

    const titleRow = <Row style={{ fontSize:'0.9em', fontWeight:'bold'}}>
    <Col xs='12'><Row>
        <Col style={{textAlign: 'center'}} xs='4'> Student </Col>
        <Col style={{textAlign: 'center'}} xs='4'> Operation </Col>
        <Col style={{textAlign: 'center'}} xs='1'>+</Col>
        <Col style={{textAlign: 'center'}} xs='1'>-</Col>
        <Col style={{textAlign: 'center'}} xs='1'>*</Col>
        <Col style={{textAlign: 'center'}} xs='1'>/</Col>
        </Row></Col>
    </Row>;

    return <>
        {Object.keys(processedMarks).length < selectedStudents.length && <center> <p>  Students without marks will not appear in this report </p></center>}
        <br/>
        {!isObjectEmpty(processedMarks) && <>
            {headerComp}
            <hr/>
            <Row style={{textAlign:'center', fontSize:'0.9em', fontWeight:'bold'}} >
                <Col xs='4'></Col>
                <Col xs='4'>Current</Col>
                <Col xs='4'>Cumulative Mastered Facts</Col>
            </Row>

            {titleRow}

            {/* reorder marks into alphabetical order but for some reason this is not needed?
                {toArray(processedMarks)
                .sort((a,b) => (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : (a.Name.toUpperCase() === b.Name.toUpperCase() ? -1 : 0))
                .map((e, i) => (
                    <StudentRow  key={i} name={e.Name} tableData={e}/> 
                ))
            } */}

            {Object.keys(processedMarks).map((key, i) => (
                <StudentRow  key={i} name={key.split('+')[1]} tableData={processedMarks[key]}/> 
            ))}

            <Row style={{fontSize:'0.9em',fontWeight:'bold'}}>        
                <Col style={{textAlign: 'center'}} xs='4'>  </Col>
                <Col style={{textAlign: 'center'}} xs='4'>  </Col>
                <Col style={{textAlign: 'center'}} xs='1'>{totals.AddMastered}</Col>
                <Col style={{textAlign: 'center'}} xs='1'>{totals.SubMastered}</Col>
                <Col style={{textAlign: 'center'}} xs='1'>{totals.MultMastered}</Col>
                <Col style={{textAlign: 'center'}} xs='1'>{totals.DivMastered}</Col>
            </Row>        
        </>}
    </>;
};

const StudentRow = ({name, tableData}) => {    
    console.log('tableData',tableData);
    const { Mastered: AddMastered } = tableData.ADD || 0;
    const { Mastered: SubMastered } = tableData.SUB || 0;
    const { Mastered: MultMastered } = tableData.MULT || 0;
    const { Mastered: DivMastered } = tableData.DIV || 0;

    return (
        <Row style={{fontSize:'0.9em'}}>        
            <Col style={{textAlign: 'center'}} xs='4'> {name} </Col>
            <Col style={{textAlign: 'center'}} xs='4'> {tableData.CurrentFact.fact} </Col>
            <Col style={{textAlign: 'center'}} xs='1'>{AddMastered || '0'}</Col>
            <Col style={{textAlign: 'center'}} xs='1'>{SubMastered || '0'}</Col>
            <Col style={{textAlign: 'center'}} xs='1'>{MultMastered || '0'}</Col>
            <Col style={{textAlign: 'center'}} xs='1'>{DivMastered || '0'}</Col>
        </Row>
    );
};

export default ContainerComp;